package org.matthewo.collections

private class NullsLastComparator<T>(val comparator: Comparator<T>) : Comparator<T> {
    override fun compare(a: T, b: T) = when {
        a === b -> 0
        a == null -> 1
        b == null -> -1
        else -> comparator.compare(a, b)
    }
}

fun <T> Comparator<T>.nullsLast(): Comparator<T> = NullsLastComparator(this)
